// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { PurchaseOrder, purchaseOrderSchema } from '@/purchase-order/api/types';
import { z } from 'zod';

const getPurchaseOrderResponseSchema = z.object({
  data: purchaseOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Fetches a single purchase order by its key.
 */
export async function getPurchaseOrder(
  purchaseOrderKey: string
): Promise<PurchaseOrder> {
  const url = `/v1/purchase-order/${purchaseOrderKey}`;
  const response = await api.get(url);

  const { data } = await parseResponse(
    getPurchaseOrderResponseSchema,
    response.data,
    {
      schemaName: 'GetPurchaseOrder',
      endpoint: url,
    }
  );
  return data;
}
